import {
	Button,
	AlertDialog,
	AlertDialogOverlay,
	AlertDialogContent,
	AlertDialogHeader,
	AlertDialogBody,
	AlertDialogFooter,
} from "@chakra-ui/react"
import React from "react"
import { ErrorMessageField } from "../ui"

const DeleteItemDialog = ({
	title,
	subtitle,
	errorMessage,
	isOpen,
	cancelRef,
	onCancel,
	onDelete,
	isLoading,
	extendedBody,
	actionText,
}: {
	title: string
	subtitle?: string | JSX.Element
	errorMessage?: string | null
	isOpen: boolean
	cancelRef?: React.MutableRefObject<null>
	onCancel?: Function
	onDelete?: Function
	isLoading?: boolean
	extendedBody?: JSX.Element
	actionText?: string
}) => {
	return (
		<AlertDialog
			isOpen={isOpen}
			leastDestructiveRef={cancelRef}
			onClose={() => (onCancel ? onCancel() : null)}
		>
			<AlertDialogOverlay>
				<AlertDialogContent>
					<AlertDialogHeader
						fontSize="lg"
						fontWeight="bold"
						data-testid="title"
					>
						{title}
					</AlertDialogHeader>

					<AlertDialogBody>
						{subtitle ??
							`Are you sure? You can't undo this action afterwards.`}

						{errorMessage && (
							<ErrorMessageField> {errorMessage} </ErrorMessageField>
						)}

						{extendedBody}
					</AlertDialogBody>

					<AlertDialogFooter>
						<Button
							ref={cancelRef}
							onClick={() => (onCancel ? onCancel() : null)}
							data-testid="cancel-btn"
						>
							Not Now
						</Button>
						<Button
							colorScheme="red"
							onClick={() => (onDelete ? onDelete() : null)}
							ml={3}
							data-testid="delete-btn"
							isLoading={isLoading}
							isDisabled={isLoading}
						>
							{actionText ?? "Delete"}
						</Button>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialogOverlay>
		</AlertDialog>
	)
}

export default DeleteItemDialog
